import useCurrentBranchData from "@/hooks/useCurrentBranchData"
import { useNavigatorContext } from "@/components/BranchNavigator"

export default function useInfoData(data) {
	const branch = useCurrentBranchData()
	const { isTextileCollection } = useNavigatorContext()
	const headers = {
		hq: data?.hqHeader || "",
		contact: data?.contactHeader || "",
		bankAccount: data?.bankAccountHeader || "",
	}
	const bankAccount = {
		title: branch.bankAccount?.title || "",
		helper: branch.bankAccount?.helperText1 || "",
		value: branch.bankAccount?.value || "",
	}
	const contact = branch.contactEntities || []
	const overflowingContainerText = branch?.overflowingContainerText || ""
	const textileCollectionContactEntities = branch?.textileCollectionContactEntities || []
	const finalContactEntities = isTextileCollection ? textileCollectionContactEntities : contact
	const finalAddress = isTextileCollection ? branch.address : branch.address

	return {
		headers,
		bankAccount,
		overflowingContainerText,
		contactEntities: finalContactEntities,
		address: finalAddress,
	}
}
